import { z } from "zod";
import { acknowledgedResponseSchema } from "./common.js";
export const updateGoldPricesSchema = z.object({
    prices: z
        .array(z.object({
        karat: z.number().int().min(1).max(24),
        pricePerGram: z.number().nonnegative().max(100_000),
        fineness: z.number().min(0).max(1000).optional(),
        karatLabel: z.string().max(20).optional(),
    }))
        .min(1)
        .max(20),
    overrideHours: z
        .number()
        .min(0)
        .max(24 * 30)
        .default(24),
    reason: z.string().max(200).optional(),
});
export const releaseGoldPriceOverrideSchema = z
    .object({ karat: z.number().int().min(1).max(24).optional() })
    .default({});
export const updateGoldPricesResponseSchema = z.object({
    updated: z.number(),
    manualOverrideUntil: z.number().nullable(),
});
export const releaseGoldPriceOverrideResponseSchema = z.object({ released: z.number() });
export const refreshGoldPricesResponseSchema = z.object({
    kaRasmussen: z.object({
        fetchedAt: z.number().nullable(),
        error: z.string().nullable(),
    }),
    spotReference: z.object({
        fetchedAt: z.number().nullable(),
        error: z.string().nullable(),
    }),
    currentPriceUpdated: z.boolean(),
    activeManualOverride: z.boolean(),
    maxDivergencePct: z.number().nullable(),
});
export const acknowledgeGoldPriceAlertResponseSchema = acknowledgedResponseSchema;
